import { computed, inject } from '@angular/core';
import { ApiService } from '@libs/core/base-config';
import { AuthStateStore } from '@libs/core/lib/auth/auth-state.store';
import { asResult, dataFromState } from '@libs/core/lib/state/async-states';
import { loggedInUser } from '@libs/mtjr/shared/generated/entities/user/service/user.service';
import {
  withAddFCMToken,
  withLoggedInUser,
  withRemoveFCMToken,
} from '@libs/mtjr/shared/generated/entities/user/user-store-features';
import { patchState, signalStore, withComputed, withMethods } from '@ngrx/signals';

export const UserStore = signalStore(
  { providedIn: 'root' },
  withLoggedInUser(),
  withAddFCMToken(),
  withRemoveFCMToken(),
  withMethods((store, apiService = inject(ApiService), authStore = inject(AuthStateStore)) => ({
    async fetchUserIfNeeded() {
      if (await authStore.checkAuthState()) {
        const state = store.loggedInUserState();
        if (state.type === 'initial' || state.type === 'error') {
          return store.loggedInUser();
        }
      }
    },
    resetState() {
      patchState(store, { loggedInUserState: { type: 'initial', success: false } });
    },
    // reload user without emitting loading state
    async refreshLoggedInUser() {
      const result = await asResult(loggedInUser(apiService));
      patchState(store, { loggedInUserState: result });
    },
  })),

  withComputed((store) => ({
    isStateInitial: computed(() => store.loggedInUserState().type === 'initial'),
    userName: dataFromState(store.loggedInUserState, (state) => state?.email),
    userId: dataFromState(store.loggedInUserState, (state) => state?.id),
    profileImage: dataFromState(store.loggedInUserState, (state) => {
      if (state?.avatar == null) return 'avatar.jpg';
      return state?.avatar;
    }),
    name: dataFromState(store.loggedInUserState, (state) => state?.name ?? null),
    addresses: dataFromState(store.loggedInUserState, (state) => state?.addresses ?? []),
    wishListItems: dataFromState(store.loggedInUserState, () => [] as any[]),
  })),
);
